import { render, staticRenderFns } from "./shpAdvance.vue?vue&type=template&id=0b7c0120&scoped=true"
import script from "./shpAdvance.vue?vue&type=script&lang=js"
export * from "./shpAdvance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7c0120",
  null
  
)

export default component.exports